// separating instance configuration out into its own file for easy swapping
// means putting a script file in the public directory that sets a window global.
// not pretty, but it works
export default window.__instanceConfig
